<app-header [currentUser]="currentUser()" />

<main>
  <router-outlet />
</main>

@if (showFooter()) {
  @defer (on idle) {
    <app-footer />
  } @placeholder {
    <div class="footer-placeholder"></div>
  }
}
